import * as React from "react";
import { UitkCardAloha, UitkCardAlohaLink } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { Viewport, ViewSmall, ViewMedium, ViewLarge } from "bernie-view";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { TripCardProps } from "../typings";
import { locKeys } from "../l10n";
import { TripCardContent } from "./TripCardContent";
import { useLocalization } from "@shared-ui/localization-context";

export const TripCard = (props: TripCardProps) => {
  const { formatText } = useLocalization();

  const tripTitle = formatText(locKeys.tripTitle, props.destinationName);
  const tripCardContent = (
    <TripCardContent
      destinationName={props.destinationName}
      imageData={props.imageData}
      tripEndDate={props.tripEndDate}
      tripStartDate={props.tripStartDate}
      tripTitle={tripTitle}
    />
  );

  return (
    <UitkCardAloha border={props.withBorder} className="tripCard">
      <UitkCardAlohaLink>
        <TrackedLink
          href="/trips"
          linkName="RFRR Trip Action Link"
          moduleName={props.moduleName}
          rfrr="SF_trip_CTA_MVP"
        >
          {tripTitle}
        </TrackedLink>
      </UitkCardAlohaLink>
      <Viewport>
        <ViewSmall>
          <UitkFigure className="ratio-3-1">{tripCardContent}</UitkFigure>
        </ViewSmall>
        <ViewMedium>
          <UitkFigure ratio={UitkFigureAspectRatioType.R3_2}>{tripCardContent}</UitkFigure>
        </ViewMedium>
        <ViewLarge>
          <UitkFigure className="ratio-3-1">{tripCardContent}</UitkFigure>
        </ViewLarge>
      </Viewport>
    </UitkCardAloha>
  );
};

export default TripCard;
